import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import {
    fetchCategoriesFailure,
    fetchCategoriesSuccess,
    fetchCategoryFailure,
    fetchCategorySuccess,
} from 'store/actions/categories/fetchCategories';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';

function* fetchCategoriesAsync({ payload }) {
    const params = payload.params || {
        size: payload.size,
        offset: payload.offset,
        sort_by: payload.sort.field,
        sort_direction: payload.sort.order,
    };

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/categories`;

        // Fetch the data.
        const response = yield apiClient.read(url, params);

        // Send the data the success action.
        yield put(fetchCategoriesSuccess(response));
    } catch (error) {
        // Trigger the error action.
        yield put(fetchCategoriesFailure(error));
    }
}

function* fetchCategoryAsync({ payload }) {
    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/categories/${ payload.id }`;

        // Fetch the data.
        const response = yield apiClient.read(url);

        // Send the data to the success action.
        yield put(fetchCategorySuccess(response));
    } catch (error) {
        // Trigger the error action.
        yield put(fetchCategoryFailure(error, payload));
    }
}

function* failureMessage({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

export default function* activitiesSagas() {
    yield [
        takeEvery('FETCH_CATEGORIES', fetchCategoriesAsync),
        takeEvery('FETCH_CATEGORIES_FAILURE', failureMessage),

        takeEvery('FETCH_CATEGORY', fetchCategoryAsync),
        takeEvery('FETCH_CATEGORY_FAILURE', failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/categoriesSagas.js